import React from 'react';
import { useTranslation } from 'react-i18next';
import { HtmlTrans, Typography } from 'web-library';



import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) =>
({
  orderList: {
    marginBottom: theme.spacing(6),
  },
  a: {
    textDecoration: 'none',
    color: theme.color.link.linkDefault01,
  },
}));

const IpsleInstruction = () => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  return (
    <>
      <ol className={classes.orderList}>
        <li>
          <Typography variant="body1">
            {t('withdrawal->>Coordinator.Instruction.Content1Ipsle')}
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            {t('withdrawal->>Coordinator.Instruction.Content2Ipsle')}
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            {t('withdrawal->>Coordinator.Instruction.Content3Ipsle')}
          </Typography>
        </li>
      </ol>
      <Typography variant="body1">
        <HtmlTrans
          i18nKey="withdrawal->>Coordinator.Instruction.ForMoreInformation"
          values={{
            aClass: classes.a,
          }}
        />
      </Typography>
    </>
  );
};
export default IpsleInstruction;
